export const locale = {
    lang: 'en',
    data: {
        'NOW': "Now"
    }
};
